import React, { useState } from 'react';
import '../catalogue/styles.css';
import {
  Input,
  InputGroup,
  Button,
  Nav,
  Stack,
  Breadcrumb,
  Divider,
  Panel,
  Placeholder,
  Container,
  Col,
  Row,
  Checkbox,
  Modal,
  useToaster,
  Uploader,
  Message,
  Loader
} from 'rsuite';




const ClientWeb = () => {
  const [activeKey, setActiveKey] = useState('content1');
  const handleNavSelect = (eventKey) => {
    setActiveKey(eventKey);
  };

  
 

  return (
    <>
      <Container className='main'>
        <Stack className="table-toolbar" justifyContent="space-between">
          <Stack direction='column' alignItems='flex-start'>
            <Stack direction='column' alignItems='flex-start' >
              <h3 className="title">Client</h3>
              <Breadcrumb>
                <Breadcrumb.Item href="/dashboard">Home</Breadcrumb.Item>
                <Breadcrumb.Item active>Client</Breadcrumb.Item>
              </Breadcrumb>
            </Stack>
            <Stack>
              <Nav appearance="tabs" activeKey={activeKey} onSelect={handleNavSelect} style={{ display: 'flex', gap: '20px' }}>
                <Nav.Item eventKey="content1"><b>Login Page</b></Nav.Item>
                <Nav.Item eventKey="content2"><b>Landing Page</b></Nav.Item>
                <Nav.Item eventKey="content3"><b>Product View</b></Nav.Item>
                <Nav.Item eventKey="content4"><b>Control</b></Nav.Item>
                <Nav.Item eventKey="content5"><b>Shortlist </b></Nav.Item>
                <Nav.Item eventKey="content6"><b>Quote  </b></Nav.Item>
              </Nav>
            </Stack>
          </Stack>
        </Stack>
        <Divider className='divide' />
        <div className="row">
          <Panel>
            

          </Panel>

        </div>
        <Stack className="copyright"    justifyContent="flex-end" spacing={5} style={{ 'position': 'fixed', 'bottom': '0', 'width': '-webkit-fill-available', 'textAlign': 'center', 'backgroundColor': 'white', 'paddingRight': '16px' }}>
          <p>© All Right Reserved. Product by </p><p> <a href="https://erpdaddy.com/" target="_blank">ERP Daddy Softwere Solution.</a></p>
        </Stack>
      </Container>
    </>
  );
};
export default ClientWeb;
